<template>
  <div class="soar-container">
    <div class="w-full my-8">
      <div class="flex items-center justify-between border-b border-brand-gray-350 w-full">
        <div class="py-6 w-full">
          <h2 class="text-xl text-gray-500 font-normal mx-3">
            {{ $t('eidaProceduresExceptionDetails') }}
          </h2>
        </div>
      </div>
      <CollapsibleSection v-for="(item, key) in simpleInfo" :key="key" :header-label="item.header">
        <div class="flex flex-row flex-wrap justify-center items-center w-full">
          <div
            v-for="(value, vKey) in item.values"
            :key="vKey"
            class="flex flex-row w-full lg:w-1/2 gap-2"
          >
            <div v-if="value.value" class="flex flex-row w-full gap-2">
              <div class="text-gray-400">{{ value.label }} :</div>
              <div>{{ value.value }}</div>
            </div>
          </div>
        </div>
      </CollapsibleSection>
      <CollapsibleSection :header-label="$t('requestActions')">
        <div class="w-full my-6">
          <DataTable
            :default-headers="['requestActions', 'actionComment', 'CreationDate']"
            :data-set="processedDataTable"
            v-if="processedDataTable.length > 0"
            class="w-full"
          >
            <template #cell="{ columnName, columnValue, rowIndex }">
              <div class="min-h-4">{{ columnValue }}</div>
            </template>
          </DataTable>
        </div>
      </CollapsibleSection>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import DataTable from '@/components/DataTable/index.vue'
import apiHelperService from '@/services'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import lookups from '@/assets/json/clientLookups.json'

const processedDataTable = ref([])
const formatAppendRow = ref([])
const request = ref()

const i18n = useI18n()
const route = useRoute()
const containsVat = ref(false)

const simpleInfo = ref([])
const disableExceptionsInformation = ref()

const setTotal = (val) => {
  formatAppendRow.value = [
    [
      {
        label: i18n.t('total'),
        value: val,
        config: {
          colspan: '4'
        }
      }
    ]
  ]
}

const fetchData = async () => {
  const {
    FingerprintEnrolmentOneRequest,
    FingerprintEnrolmentPermanent,
    PersonalPhotoVerificationIcaoOneRequest,
    PersonalPhotoVerificationIcaoPermanent
  } = lookups.exceptionalTypes
  const response = await apiHelperService.get(
    `/api/avoidConflicts/get/eidaProceduresExceptions/${route.params.id}`
  )

  request.value = response
  request.value.attachments = response.attachments

  if (
    [FingerprintEnrolmentOneRequest, FingerprintEnrolmentPermanent].includes(
      response.userBasicInfoRecordType
    )
  ) {
    request.value.fingerprintEnrolment = true
    disableExceptionsInformation.value = true

    request.value = {
      ...request.value,
      fingerprintExceptionalTypeId: response.userBasicInfoRecordType,
      allowNumberOfDaysFingerprint: response.allowNumberOfDays,
      fingerPrintExceptionalReason: response.exceptionalReason
    }
  } else if (
    [PersonalPhotoVerificationIcaoOneRequest, PersonalPhotoVerificationIcaoPermanent].includes(
      response.userBasicInfoRecordType
    )
  ) {
    request.value.personalPhotoVerification = true
    disableExceptionsInformation.value = true

    request.value = {
      ...request.value,
      icaoExceptionalTypesId: response.userBasicInfoRecordType,
      allowNumberOfDaysIcao: response.allowNumberOfDays,
      icaoExceptionalReason: response.exceptionalReason
    }
  }

  processedDataTable.value = request.value.expoStatuses.map((item) => {
    return {
      requestActions: item.lookupActionId,
      actionComment: item.lookupRejectReasonId,
      CreationDate: item.creationDate
    }
  })
}

const setSimpleInfo = () => {
  simpleInfo.value = []
  simpleInfo.value = [
    {
      header: i18n.t('beneficiaryidentificationInformation'),
      values: [
        {
          label: i18n.t('unifiedNumber'),
          value: request.value.personUnifiedNumber
        },
        {
          label: i18n.t('identityNumber'),
          value: request.value.personUnifiedNumber
        }
      ]
    },
    {
      header: i18n.t('personInfo'),
      values: [
        {
          label: i18n.t('englishName'),
          value: request.value.englishName
        },
        {
          label: i18n.t('arabicName'),
          value: request.value.arabicName
        },
        {
          label: i18n.t('CurrentNationality'),
          value: request.value.currentNationalityId
        },
        {
          label: i18n.t('gender'),
          value: request.value.genderId
        },
        {
          label: i18n.t('dateOfBirth'),
          value: request.value.dateOfBirth
        }
      ]
    },
    {
      header: i18n.t('exceptionsInformation'),
      values: [
        {
          label: i18n.t('fingerprintEnrolment'),
          value: request.value.fingerprintExceptionalTypeId
        },
        {
          label: i18n.t('allowNumberOfDaysException'),
          value: request.value.allowNumberOfDaysFingerprint
        },
        {
          label: i18n.t('icaoExceptionDuration'),
          value: request.value.icaoExceptionalTypesId
        },
        {
          label: i18n.t('allowNumberOfDaysException'),
          value: request.value.allowNumberOfDaysIcao
        },
        {
          label: i18n.t('reason'),
          value: request.value.icaoExceptionalReason
        }
      ]
    },
    {
      header: i18n.t('contactInformation'),
      values: [
        {
          label: i18n.t('watermarkMobile'),
          value: request.value.localMobileNumber
        },
        {
          label: i18n.t('applicantEmail'),
          value: request.value.applicantEmail
        }
      ]
    }
  ]
}

onMounted(async () => {
  await fetchData()
  setSimpleInfo()
})
</script>
<style lang="scss" scoped></style>
